<template>
  <div>
    <DataTable
      :value="new Array(rows)"
      stripedRows
      showGridlines
      responsiveLayout="scroll"
    >
      <Column v-for="el in columns" :key="el">
        <template #header>
          <Skeleton v-bind="{ width: '100%' }" />
        </template>
        <template #body>
          <Skeleton v-bind="{ width: '75%' }" />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    columns: {
      type: Number,
      default: 2,
    },
  },
});
</script>

<style lang="scss" scoped></style>
